import {
  WAREHOUSE_GRAPH_DATA,
  WAREHOUSE_REPORT,
  WAREHOUSE_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

//division, department, vendor, location
export const getWarehouseTableData = (
  aggr,
  division,
  department,
  vendor,
  location,
  page,
  limit,
  sort_column,
  sort_order
) => {
  const requestURL = WAREHOUSE_TABLE_DATA;
  let obj = {
    aggregate_column: aggr,
    sort_column: sort_column,
    sort_order: sort_order,
  };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWarehouseGraphData = (
  division,
  department,
  vendor,
  location
) => {
  const requestURL = WAREHOUSE_GRAPH_DATA;
  let obj = {};

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWarehouseReport = (division, department, vendor, location) => {
  const requestURL = WAREHOUSE_REPORT;
  let obj = {};

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
